import React, { Component } from 'react';
import { ACTOR, FLOW_TYPE } from '../../../framework/App/AppConstants';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import RedirectButton from '../../../shared-components/RedirectButton/RedirectButton';
import StickyFooter from '../../../shared-components/StickyFooter/StickyFooter';
import { REDIRECT_SUFFIX } from '../../config/pageNames';
import '../../styles/base-us.less';
import PageHeaderText from '../../../shared-components/Typography/PageHeaderText';

const LOCALE_PREFIX = 'US/pages/IneligibilityPage/IneligibilityPage';

export class IneligibilityPage extends Component {
    static propTypes = {
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)),
        actor: PropTypes.oneOf(Object.values(ACTOR)),
        eligibilityDeclineMessage: PropTypes.string,
        intl: intlShape.isRequired,
        onComponentDidMount: PropTypes.func.isRequired
    };
    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount();
    }

    render() {
        const { intl, flow, actor, eligibilityDeclineMessage } = this.props;
        const messageHeader = intl.formatMessage({ id: `${LOCALE_PREFIX}.${eligibilityDeclineMessage}.headerMessage` });
        const messagePara = intl.formatMessage({ id: `${LOCALE_PREFIX}.${eligibilityDeclineMessage}.messagePara` });
        let continueText = intl.formatMessage({ id: `${LOCALE_PREFIX}.continue` });

        if (flow === FLOW_TYPE.DIRECT_APP && actor === ACTOR.MERCHANT) {
            continueText = intl.formatMessage({ id: `${LOCALE_PREFIX}.continueDAMerchant` });
        }

        return (
            <div>
                <div className="outerWrapper us-wrapper">
                    <div id="wrapper">
                        <div id="main">
                            <Header singleColumnLayout={true} displayLogout={(flow === FLOW_TYPE.DIRECT_APP)} />
                            <section id="ineligible" className="contentSection">
                                <div className="row-fluid container">
                                    <span className="span24">
                                        <PageHeaderText>{messageHeader}</PageHeaderText>
                                        <p>{messagePara}</p>
                                        <div className="row-fluid">
                                            <span className="span14">
                                                <div className="buttons">
                                                    <RedirectButton
                                                        buttonId="ineligibleContinue"
                                                        ctaLabel={continueText}
                                                        actionUri={REDIRECT_SUFFIX.RETURN_REDIRECT}
                                                    />
                                                </div>
                                            </span>
                                        </div>
                                    </span>
                                </div>
                            </section>
                        </div>
                    </div>
                    <StickyFooter fixToBottom={true} fadedBackground={true}>
                        <Footer showCancelUrl={false} />
                    </StickyFooter>
                </div>
            </div>
        );
    }
}

export const mapStateToProps = state => ({
    flow: state.serverData.flow,
    actor: state.serverData.actor,
    eligibilityDeclineMessage: state.serverData.eligibilityDeclineMessage
});

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount() {
        dispatch(trackTransition('pp_credit_ineligiblepage', 'prepare_pp_credit_ineligiblepage'));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(IneligibilityPage));
